import { GoalStatus } from "hooks/api/documentGeneration/useGetDocumentChecklist";

export interface NotIncludedReason {
  description: string;
  buttonText: string;
}

export type GoalsViewMode = "withoutProgress" | "withProgress" | "hoursAddendum";

// RTP / 90-Day let missing-baseline goals through (BE buckets them as "new"); ITP hard-blocks;
// HAR surfaces missing-baseline goals as "new" so the request captures every relevant goal.
export const isGoalNotIncluded = (goal: GoalStatus, goalsView: GoalsViewMode): boolean => {
  if (goal.isMissingReplacementBehavior) return true;
  if (goalsView === "withoutProgress" && goal.isMissingBaselineData) return true;
  return false;
};

export const getNotIncludedReason = (
  goal: GoalStatus,
  goalsView: GoalsViewMode
): NotIncludedReason | null => {
  if (goalsView === "withoutProgress" && goal.isMissingBaselineData) {
    return { description: "No baseline data available", buttonText: "Add Baseline Data" };
  }
  if (goal.isMissingReplacementBehavior) {
    return {
      description:
        "Each behavior reduction goal must be associated with at least one behavior acquisition target",
      buttonText: "Add Target",
    };
  }
  return null;
};
